import type { WorkShiftCell } from "@senciamatch/shared/models/workShiftCell";

interface Props {
  workShiftCell: WorkShiftCell | undefined;
  isModified?: boolean;
}

const CellNull = () => {
  return (
    <td className="border border-gray-100 w-[270px] h-[80px]">
      <div className="flex items-center justify-center h-full w-[270px]">
        <div className="text-gray-500">-</div>
      </div>
    </td>
  );
};

export const Cell = (props: Props) => {
  const { workShiftCell, isModified = false } = props;

  if (!workShiftCell) return <CellNull />;

  // 変更されたセルは緑色の背景でハイライト
  const bgClass = isModified ? "bg-green-100" : "";
  const borderClass = isModified ? "border-green-500 border-2" : "border-gray-100";

  return (
    <td className={`border ${borderClass} w-[270px] h-[80px]`}>
      <div className={`flex flex-col items-center justify-center h-full w-[270px] relative ${bgClass}`}>
        <div className="absolute top-2 left-2">
          {workShiftCell.status === "Confirmed" && <img src="/icons/confirmed.svg" alt="confirmed" />}
          {workShiftCell.status === "NotConfirmed" && <img src="/icons/not_confirmed.svg" alt="not confirmed" />}
        </div>
        <p className="text-center font-medium">{workShiftCell.staffName}</p>
        <p className="text-center text-sm">
          {workShiftCell.shiftSymbol}({String(workShiftCell.startHour).padStart(2, "0")}:
          {String(workShiftCell.startMinute).padStart(2, "0")} - {String(workShiftCell.endHour).padStart(2, "0")}:
          {String(workShiftCell.endMinute).padStart(2, "0")})
        </p>
        {workShiftCell.isFirstShift && <p className="text-blue-500 text-sm">初担当</p>}
        {isModified && (
          <div className="absolute bottom-1 right-1">
            <span className="text-xs bg-green-600 text-white px-2 py-1 rounded">変更</span>
          </div>
        )}
      </div>
    </td>
  );
};
